import LabelTextGroupList from './LabelTextGroupList';
import { LabelTextGroupListProps, LabelTextGroupListValueProps } from './types';

export type { LabelTextGroupListProps, LabelTextGroupListValueProps };
export default LabelTextGroupList;
